import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { environment } from "../../../environments/environment";
import { BasicDetails, ProposalStatus } from "./ulb-pts-wrapper/model";
import { Item } from "./model";

@Injectable({
  providedIn: "root",
})
export class UlbProposalService {
  fileUrl: string = environment.config.fileGeneration;
  proposalUrl = environment.config.pts;
  pmsUrl = environment.config.pms;
  classificationUrl = environment.config.classification;
  analysisUrl = environment.config.analysis;
  pdfUrl = environment.config.fileGeneration;
  reportUrl = environment.config.apiUrl;
  gtlUrl = environment.config.gtlUrl;
  selectedSector;
  selectedClusterULB;
  proposalSummary;
  projects: { projectId: number; projectUniqueId: string }[];
  analysisReport$ = new BehaviorSubject<BasicDetails>(null);
  cbProject$ = new BehaviorSubject<any>(null);
  ClusterUlbDetails = new Subject();
  uniqueProposalId;
  isSubmitted;
  proposalStatus;

  query: { id?: number; sector?: string; mode?: string } = {};

  constructor(private http: HttpClient) {}

  resetProposalDetails() {
    this.selectedSector = null;
    this.uniqueProposalId = null;
    this.isSubmitted = null;
    this.proposalStatus = null;
    this.projects = [];
    this.query = {};
    this.analysisReport$.next(null);
  }

  isEditable() {
    if (this.query?.id) {
      return (
        !this.isSubmitted && this.proposalStatus === ProposalStatus.DRAFTED
      );
    }
    return false; // Because Proposal not yet created.
  }

  getCitySummaryItems(detail): Item[] {
    return [
      { label: "Action Plan Id", value: detail?.uniqueProposalId || "" },
      { label: "Sector", value: detail?.sectorName || "" },
      { label: "Total Projects", value: detail?.totalProjects || "" },
      {
        label: "Total Proposal Cost",
        value: detail?.totalCost || "",
        amount: true,
      },
    ];
  }
  getStateSummaryItems(detail): Item[] {
    return [
      { label: "State", value: detail?.stateName || "" },
      { label: "Sectors", value: detail?.sectors || "" },
      {
        label: "Total Allocation",
        value: detail?.sbmAllocation || "",
        amount: true,
      },
      {
        label: "Total Requested Cost",
        value: detail?.estimatedCost || "",
        amount: true,
      },
    ];
  }

  getMOM(url: string, data) {
    const headers = new HttpHeaders().set("Content-Type", "application/pdf");
    return this.http.post<any>(this.fileUrl + url, data, {
      headers,
      observe: "response",
      responseType: "blob" as "json",
    });
  }

  // Common CRUD methods......
  saveCBmonitoringEmpty(url: string, data) {
    return this.http.post<any>(this.proposalUrl + url, data, {
      observe: "response",
    });
  }

  SKPOrganizationList(url: string) {
    return this.http.get<any>(this.proposalUrl + url, {
      observe: "response",
    });
  }

  save(url: string, data) {
    return this.http.post<any>(this.proposalUrl + url, data, {
      observe: "response",
    });
  }
  update(url: string, data) {
    return this.http.put<any>(this.proposalUrl + url, data, {
      observe: "response",
    });
  }
  delete(url: string, id) {
    return this.http.delete<any>(this.proposalUrl + url + id, {
      observe: "response",
    });
  }
  getDetail(url: string, id) {
    return this.http.get<any>(this.proposalUrl + url + id, {
      observe: "response",
    });
  }
  getList(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
    });
  }
  getAllCBmonitoring(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url + "getAllCBmonitoring", {
      params: queryData,
      observe: "response",
    });
  }
  getCBmonitoring(url: string, id) {
    return this.http.get<any>(
      this.proposalUrl + url + "getCBmonitoring/" + id,
      {
        observe: "response",
      }
    );
  }
  deleteCBmonitoring(url: string, id) {
    return this.http.delete<any>(
      this.proposalUrl + url + "deleteCBmonitoring/" + id,
      {
        observe: "response",
      }
    );
  }
  getSectors(params = {}) {
    return this.http.get<any>(this.classificationUrl + "classification", {
      params,
      observe: "response",
    });
  }
  getCbiec(params = {}) {
    return this.http.get<any>(this.classificationUrl + "classification", {
      params,
      observe: "response",
    });
  }
  getDynamicTypeDropDown(type: string) {
    return this.http.get<any>(this.proposalUrl + "pts/sectors/" + type);
  }

  getAnalysis(sector) {
    return this.http.get<any>(this.analysisUrl + sector, {
      observe: "response",
    });
  }
  getAnalysisCluster(sector, data) {
    return this.http.post<any>(this.analysisUrl + sector, data, {
      observe: "response",
    });
  }
  // save(url: string, data) {
  //   return this.http.post<any>(this.proposalUrl + url, data, { observe: 'response' });
  // }
  approveAndReject(url: string, params, data) {
    return this.http.put<any>(this.proposalUrl + url, data, {
      params,
      observe: "response",
    });
  }
  generatePdf(data, params) {
    const headers = new HttpHeaders().set("Content-Type", "application/pdf");
    return this.http.post<any>(this.pdfUrl + "htmltopdf", data, {
      params,
      headers,
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  getExcelDownloadDetails(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  getExcelDownloadDetailsId(url: string, id) {
    return this.http.get<any>(this.proposalUrl + url + id, {
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  getListDownload(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  getCSTExcelDownloadDetails(url: string) {
    return this.http.get<any>(this.reportUrl + url, {
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  getStateDetails(url: string, id: string) {
    return this.http.get<any>(this.proposalUrl + url + id, {
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  getNationalDetails(url: string) {
    return this.http.get<any>(this.proposalUrl + url, {
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  getCSWExcelDownloadDetails(url: string) {
    return this.http.get<any>(this.reportUrl + url, {
      observe: "response",
      responseType: "blob" as "json",
    });
  }

  // CRUD CB Calender 

  saveCBCalender(url: string, data) {
    return this.http.post<any>(this.proposalUrl + url, data, {
      observe: "response",
    });
  }

  getCBCalendersByStateId(url: string,queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
    });
  }

  getCBCalenderById(url: string, id) {
    return this.http.get<any>(
      this.proposalUrl + url + "getCBCalender/" + id,
      {
        observe: "response",
      }
    );
  }

  isRecordCBYearlyPresent(url, data){
    return this.http.post<any>(this.proposalUrl + url + "isRecordPresent", data, {
      observe: "response",
    });
  }

  getDownloadReportExcel(url: string,queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      observe: "response",
      params: queryData,
      responseType: "blob" as "json",
    });
  }

  // get Sanction List 

  getSanctionList(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
    });
  }

  getReleaseList(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
    });
  }

  // PMS CRUD API LIST

  getPMSList(url: string, queryData) {
    return this.http.get<any>(this.pmsUrl + url, {
      params: queryData,
      observe: "response",
    });
  }
  getActionTypeList(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
    });
  }


  updatePms(url: string, data) {
    return this.http.put<any>(this.pmsUrl + url, data, {
      observe: "response",
    });
  }

  getPmsDetailsById(url: string) {
    return this.http.get<any>(this.pmsUrl + url, {
      observe: "response",
    });
  }

  savePms(url: string, data) {
    return this.http.post<any>(this.pmsUrl + url, data, {
      observe: "response",
    });
  }
  
  getProjectDetailsListByProjectId(url: string) {
    return this.http.get<any>(this.pmsUrl + url, {
      observe: "response",
    });
  }

  downloadPMSExcel(url: string, queryData) {
    return this.http.get<any>(this.pmsUrl + url, {
      params: queryData,
      observe: "response",
      responseType: "blob" as "json",
    });
  }

  deletePMS(url: string, id) {
    return this.http.delete<any>(
      this.pmsUrl + url + "/" + id,
      {
        observe: "response",
      }
    );
  }

  allSWMTypes(url: string){
    return this.http.get<any>(this.proposalUrl + url, {
      observe: "response",
    });
  }

  getProjectedPopulation(url: string){
    return this.http.get<any>(this.proposalUrl + url, {
      observe: "response",
    });
  }

  getSanctionDownloadExcel(url: string) {
    return this.http.get<any>(this.proposalUrl + url, {
      observe: "response",
      responseType: "blob" as "json",
    });
  }

  getConsolidatedPlan(url: string, data) {
    return this.http.post<any>(this.proposalUrl + url, data, {
      observe: "response",
    });
  }

  getDrapList(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url + "list", {
      params: queryData,
      observe: "response",
    });
  }

   getDrapExcel(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
      responseType: "blob" as "json",
    });
  }

  getDrapBasicDetails(url) {
    return this.http.get<any>(this.proposalUrl + url, {
      observe: "response",
    });
  }

  getDrapDumpsite(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
    });
  }

  getActionPlanDetailOfDumpsite(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
    });
  }

  saveDrap(url: string, formData) {
    return this.http.post<any>(this.proposalUrl + url, formData, {
      observe: "response",
    });
  }

  deletedDrap(url: string) {
    return this.http.delete<any>(this.proposalUrl + url, {
      observe: "response",
    });
  }

  getDrapedById(url:string){
    return this.http.get<any>(this.proposalUrl + url, {
      observe: "response",
    });
  }

  updateDrap(url: string, data) {
    return this.http.put<any>(this.proposalUrl + url, data, {
      observe: "response",
    });
  }

  downloadDrapTemplate(url, data) {
     return this.http.post<any>(this.proposalUrl + url, data,{
      observe: "response",
      responseType: "blob" as "json",
    });
  }

  getUlbSharePercentage(url) {
     return this.http.get<any>(this.proposalUrl + url, {
      observe: "response",
    });
  }

  updateApproveReject(url,data){
    return this.http.put<any>(this.proposalUrl + url, data, {
      observe: "response",
    });
  }

  getDrapProgress(url) {
     return this.http.get<any>(this.proposalUrl + url, {
      observe: "response",
    });
  }

  getDrapConsolidationList(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
    });
  }

  getDrapSltcApproedList(url: string, queryData) {
    return this.http.get<any>(this.proposalUrl + url, {
      params: queryData,
      observe: "response",
    });
  }

  getCreateDrapConsolidatedPlan(url: string, data) {
  return this.http.post<any>(this.proposalUrl + url, data, {
    observe: "response",
  });
}

getToiletIds(id?:any){
  return this.http.get<any>(this.gtlUrl + "toilet/v2/dropdown/" + id ,{
    observe: "body",
  });
}

}
